import { useEffect } from "react";
import { useParams } from "react-router";

import { buildRoute } from "sj-ui-toolkit/src/constants/routes";
import { useSmartNavigation } from "sj-ui-toolkit/src/helpers/navigation";

const AssessmentRedirect = () => {
  const { assignmentId } = useParams();
  const { navigateTo } = useSmartNavigation();

  useEffect(() => {
    navigateTo(buildRoute("Ka.routes.assignment.route", { assignmentId: assignmentId }));
  }, [assignmentId, navigateTo]);

  return null;
};

export default AssessmentRedirect;
